import SolicitacaoReembolso from './componentes/SolicitacaoReembolso.vue';
import SolicitacaoReembolsoLista from './componentes/SolicitacaoReembolsoLista.vue';
import SolicitacaoReembolsoForm from './componentes/SolicitacaoReembolsoForm.vue';
import SolicitacaoReembolsoRelatorio from './componentes/SolicitacaoReembolsoRelatorio.vue';

export default {
  path: '/solicitacao-reembolso-pf',
  component: SolicitacaoReembolso,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoReembolsoLista,
      name: 'solicitacao-reembolso-pf',
    },
    {
      path: 'nova',
      component: SolicitacaoReembolsoForm,
      name: 'solicitacao-reembolso-pf.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoReembolsoRelatorio,
      name: 'solicitacao-reembolso-pf.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoReembolsoForm,
      name: 'solicitacao-reembolso-pf.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-reembolso/rotas.js